// SEO utility functions for updating page titles and meta tags

export const updateMetaTag = (property: string, content: string, isProperty = true) => {
  const attribute = isProperty ? 'property' : 'name';
  let meta = document.querySelector(`meta[${attribute}="${property}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(attribute, property);
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', content);
};

export const updatePageSEO = (
  title: string,
  description: string,
  url: string = window.location.href,
  imageUrl: string = 'https://dimensionflux.com/res.png?v=5'
) => {
  // Update document title
  document.title = title;
  
  // Update meta description
  updateMetaTag('description', description, false);
  
  // Update Open Graph tags
  updateMetaTag('og:title', title);
  updateMetaTag('og:description', description);
  updateMetaTag('og:image', imageUrl);
  updateMetaTag('og:url', url);
  updateMetaTag('og:type', 'website');
  updateMetaTag('og:site_name', 'Dimension Flux');
  
  // Update Twitter tags
  updateMetaTag('twitter:title', title, false);
  updateMetaTag('twitter:description', description, false);
  updateMetaTag('twitter:image', imageUrl, false);
};

